export default {
    footer: {
        guide: 'Guide',
        faq: 'FAQ',
        termsOfService: '利用規約',
    },
};
